import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { clients as fallbackClients } from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Convert backend-relative URLs to absolute (so /api/uploads/foo.jpg works on prod)
export const resolveImageUrl = (url) => {
  if (!url) return url;
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
  if (url.startsWith("/")) return `${BACKEND}${url}`;
  return url;
};

const normalizeClient = (c) => {
  const projects = (c.projects || []).map((p) => ({ ...p, image: resolveImageUrl(p.image) }));
  return { ...c, cover: resolveImageUrl(c.cover), projects };
};

const ClientsContext = createContext({
  clients: fallbackClients,
  loading: false,
  error: null,
  reload: () => {},
});

export const ClientsProvider = ({ children }) => {
  const [clients, setClients] = useState(fallbackClients);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/clients`);
      const items = (data?.items || []).map(normalizeClient);
      if (items.length) setClients(items);
      setError(null);
    } catch (err) {
      console.warn("Failed to load clients from API — using fallback", err);
      setError(err?.message || "Failed to load clients");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <ClientsContext.Provider value={{ clients, loading, error, reload: load }}>
      {children}
    </ClientsContext.Provider>
  );
};

export const useClients = () => useContext(ClientsContext);
